import React, { useState, useEffect, useRef } from "react"
import {
  Container,
  Row,
  Col,
  InputGroup,
  Form,
  Modal,
  Button,
  Badge,
  Accordion,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap"
import {
  Phone,
  User,
  Bot,
  Briefcase,
  Calendar,
  Play,
  MessageCircle,
  ListChecks,
  Volume2,
  Sparkles,
  Star,
  Target,
  TrendingUp,
  AlertCircle,
  Search,
} from "lucide-react"
import DataTable from "react-data-table-component"
import CompanySelector from "ATSComponents/Common/CompanySelector"
import axios from "axios"
import { useForm } from "react-hook-form"
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"
import { convertISTtoEST } from "ATSComponents/Common/TimeUtils"
import Swal from "sweetalert2"
import { Dropdown } from "primereact/dropdown"
import { ProgressSpinner } from "primereact/progressspinner"
const screeningModalStyles = `
  @keyframes fadeInUp {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  @keyframes slideInLeft {
    from { opacity: 0; transform: translateX(-20px); }
    to { opacity: 1; transform: translateX(0); }
  }
  @keyframes slideInRight {
    from { opacity: 0; transform: translateX(20px); }
    to { opacity: 1; transform: translateX(0); }
  }
  @keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.05); }
  }
  @keyframes shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }
  .screening-modal .modal-content {
    border: none !important;
    border-radius: 16px !important;
    overflow: hidden;
    box-shadow: 0 25px 60px rgba(0,0,0,0.15) !important;
  }
  .screening-modal .modal-header .btn-close {
    filter: brightness(0) invert(1);
    opacity: 0.8;
  }
  .telephonic-filter-bar .job-order-filter-dropdown.p-dropdown {
    height: 31px;
    min-height: 31px;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    align-items: center;
    background: #fff;
  }
  .telephonic-filter-bar .job-order-filter-dropdown.p-dropdown:not(.p-disabled):hover {
    border-color: #86b7fe;
  }
  .telephonic-filter-bar .job-order-filter-dropdown.p-dropdown.p-focus {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.2rem rgba(13,110,253,0.15);
  }
  .telephonic-filter-bar .job-order-filter-dropdown .p-dropdown-label {
    padding: 4px 8px;
    font-size: 13px;
    line-height: 1.5;
    display: flex;
    align-items: center;
    color: #212529;
  }
  .telephonic-filter-bar .job-order-filter-dropdown .p-dropdown-label.p-placeholder {
    color: #6c757d;
  }
  .telephonic-filter-bar .job-order-filter-dropdown .p-dropdown-trigger {
    width: 26px;
    color: #6c757d;
  }
  .telephonic-filter-bar .job-order-filter-dropdown .p-dropdown-clear-icon {
    color: #9ca3af;
    right: 28px;
  }
  .telephonic-filter-bar .job-order-filter-dropdown.p-disabled {
    background: #e9ecef;
    opacity: 1;
  }

  .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
    font-size: 13px;
    padding: 8px 12px;
  }
  .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
    background: #e6f1fb;
    color: #0c447c;
  }
  .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover {
    background: #f1f5f9;
  }
  .p-dropdown-panel .p-dropdown-empty-message {
    font-size: 13px;
    padding: 10px 12px;
    color: #6c757d;
  }

  @media (max-width: 575px) {
    .telephonic-filter-bar .job-order-filter-dropdown.p-dropdown {
      width: 100% !important;
    }
  }
  .screening-modal .modal-header .btn-close:hover { opacity: 1; }
  .screening-info-card { transition: all 0.25s ease; cursor: default; }
  .screening-info-card:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,0,0,0.08); }
  .screening-question-item { transition: all 0.2s ease; }
  .screening-question-item:hover { transform: translateX(4px); box-shadow: 0 2px 8px rgba(124,58,237,0.12); }
  .screening-chat-bubble { transition: all 0.2s ease; }
  .screening-chat-bubble:hover { transform: scale(1.01); }
  .screening-section { animation: fadeInUp 0.5s ease forwards; opacity: 0; }
  .screening-avatar-candidate { transition: all 0.3s ease; }
  .screening-avatar-candidate:hover { transform: scale(1.1); }
  .screening-recording-card { transition: all 0.3s ease; }
  .screening-recording-card:hover { box-shadow: 0 4px 16px rgba(217,119,6,0.2); }
  .screening-transcript-container::-webkit-scrollbar { width: 6px; }
  .screening-transcript-container::-webkit-scrollbar-track { background: transparent; }
  .screening-transcript-container::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 3px; }
  .screening-transcript-container::-webkit-scrollbar-thumb:hover { background: #9ca3af; }
  .screening-details-pane::-webkit-scrollbar { width: 6px; }
  .screening-details-pane::-webkit-scrollbar-track { background: transparent; }
  .screening-details-pane::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 3px; }
  .screening-details-pane::-webkit-scrollbar-thumb:hover { background: #9ca3af; }
  .screening-split-body { display: flex; align-items: stretch; min-height: 0; }
  .screening-details-pane {
    flex: 1 1 58%; max-width: 58%; overflow-y: auto;
    padding: 24px 14px 28px 24px;
  }
  .screening-transcript-pane {
    flex: 1 1 42%; max-width: 42%;
    border-left: 1px solid #eef0f3;
    background: linear-gradient(180deg, #f9fafb, #f3f4f6);
    display: flex; flex-direction: column;
    padding: 24px 20px 24px 14px;
  }
  @media (max-width: 991px) {
    .screening-split-body { flex-direction: column; }
    .screening-details-pane, .screening-transcript-pane { max-width: 100%; flex: 1 1 auto; }
    .screening-transcript-pane { border-left: none; border-top: 1px solid #eef0f3; }
  }
`

const tableSpacingStyles = `
  #TelephonicTest_Table {
    overflow: hidden;
    margin-top: 12px !important;
    padding: 8px !important;
  }
  #TelephonicTest_Table .telephonic-table-scroll {
    width: 100%; overflow-x: auto; overflow-y: hidden; -webkit-overflow-scrolling: touch;
  }
  #TelephonicTest_Table .rdt_TableCol { padding: 12px 9px !important; }
  #TelephonicTest_Table .rdt_TableCell { padding: 8px 8px !important; }
  #TelephonicTest_Table .rdt_TableCol > div,
  #TelephonicTest_Table .rdt_TableCell > div { min-width: 0; }
  #TelephonicTest_Table .telephonic-col-title { font-size: 14px; font-weight: 700; white-space: nowrap; }
  #TelephonicTest_Table .telephonic-empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 70px;
    padding: 18px 16px;
    color: #475467;
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
  }
 .telephonic-filter-bar { gap: 10px; }
  .telephonic-page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 14px;
  }
  .telephonic-page-title {
    margin: 0;
    flex-shrink: 0;
  }
  .telephonic-filter-panel {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 14px 16px;
    margin-bottom: 4px;
  }
.telephonic-filter-bar {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 14px;
  width: 100%;
}
.telephonic-filter-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 140px;
  min-width: 0;
}
.telephonic-filter-group .form-select,
.telephonic-filter-group .form-control,
.telephonic-filter-group .p-dropdown {
  height: 34px;
  width: 100%;
}
.telephonic-filter-search-wrap {
  position: relative;
  flex: 1 1 auto;
}
.telephonic-filter-reset-btn {
  height: 34px;
  padding: 0 16px;
  font-weight: 600;
  font-size: 13px;
  flex: 0 0 auto;
  align-self: flex-end;
}
  .telephonic-date-error {
    margin-top: 8px;
    font-size: 12px;
    color: #dc3545;
    font-weight: 600;
  }

  .telephonic-filter-bar .job-order-filter-dropdown.p-dropdown {
    height: 34px;
    min-height: 34px;
    border: 1px solid #ced4da;
    border-radius: 0.375rem;
    align-items: center;
    background: #fff;
  }
  .telephonic-filter-bar .job-order-filter-dropdown.p-dropdown:not(.p-disabled):hover {
    border-color: #86b7fe;
  }
  .telephonic-filter-bar .job-order-filter-dropdown.p-dropdown.p-focus {
    border-color: #86b7fe;
    box-shadow: 0 0 0 0.2rem rgba(13,110,253,0.15);
  }
  .telephonic-filter-bar .job-order-filter-dropdown .p-dropdown-label {
    padding: 4px 8px;
    font-size: 13px;
    line-height: 1.5;
    display: flex;
    align-items: center;
    color: #212529;
  }
  .telephonic-filter-bar .job-order-filter-dropdown .p-dropdown-label.p-placeholder {
    color: #6c757d;
  }
  .telephonic-filter-bar .job-order-filter-dropdown .p-dropdown-trigger {
    width: 26px;
    color: #6c757d;
  }
  .telephonic-filter-bar .job-order-filter-dropdown .p-dropdown-clear-icon {
    color: #9ca3af;
    right: 28px;
  }
  .telephonic-filter-bar .job-order-filter-dropdown.p-disabled {
    background: #e9ecef;
    opacity: 1;
  }
  .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
    font-size: 13px;
    padding: 8px 12px;
  }
  .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
    background: #e6f1fb;
    color: #0c447c;
  }
  .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover {
    background: #f1f5f9;
  }
  .p-dropdown-panel .p-dropdown-empty-message {
    font-size: 13px;
    padding: 10px 12px;
    color: #6c757d;
  }
  /* ===== end filter bar layout ===== */

  .telephonic-tab-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 12px 8px;
    margin-top: 6px;
    margin-bottom: 4px;
  }
  .telephonic-tab-segment {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    background: #f8fafc;
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.75);
  }
  .telephonic-tab-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 34px;
    padding: 7px 14px;
    border: 0;
    border-radius: 7px;
    color: #475467;
    background: transparent;
    font-size: 13px;
    font-weight: 800;
    line-height: 1.2;
    transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
  }
  .telephonic-tab-button:hover {
    color: #0c447c;
    background: #eaf4fc;
  }
  .telephonic-tab-button.active {
    color: #fff;
    background: #0c447c;
    box-shadow: 0 3px 8px rgba(12,68,124,0.22);
  }
  .telephonic-tab-count {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    height: 20px;
    padding: 0 7px;
    border-radius: 999px;
    color: #0c447c;
    background: #e6f1fb;
    font-size: 11px;
    font-weight: 800;
  }
  .telephonic-tab-button.active .telephonic-tab-count {
    color: #0c447c;
    background: #fff;
  }
  .telephonic-tab-helper {
    color: #667085;
    font-size: 12px;
    font-weight: 600;
  }
  @media (max-width: 991px) {
    .telephonic-filter-bar { justify-content: flex-start; }
    .telephonic-tab-wrap { align-items: flex-start; flex-direction: column; }
  }
  @media (max-width: 575px) {
    #TelephonicTest_Table.card { padding: 6px !important; }
    #TelephonicTest_Table .rdt_TableCol { padding: 10px 7px !important; }
    #TelephonicTest_Table .rdt_TableCell { padding: 7px 7px !important; }
    #TelephonicTest_Table .telephonic-col-title { font-size: 13px; }
    .telephonic-tab-segment { width: 100%; }
    .telephonic-tab-button { flex: 1 1 0; padding: 7px 10px; }
    .telephonic-tab-helper { display: none; }
    .telephonic-filter-group,
    .telephonic-filter-panel .job-order-filter-dropdown,
    .telephonic-filter-search-wrap {
      width: 100% !important;
    }
    .telephonic-filter-divider { display: none; }
    .telephonic-filter-reset-btn { width: 100%; }
  }
`
const CustomLoader = () => (
  <OrgTableShimmer columns={6} rows={6} titleWidth="220px" />
)
const paginationComponentOptions = {
  selectAllRowsItem: true,
  selectAllRowsItemText: "All",
}
const todayStr = () => {
  const d = new Date()
  const yyyy = d.getFullYear()
  const mm = String(d.getMonth() + 1).padStart(2, "0")
  const dd = String(d.getDate()).padStart(2, "0")
  return `${yyyy}-${mm}-${dd}`
}

const formatDateTime = dateStr => {
  if (!dateStr || dateStr === "-") return "-"
  const normalized = dateStr.replace(" ", "T")
  const d = new Date(normalized)
  if (isNaN(d.getTime())) return dateStr
  const day = String(d.getDate()).padStart(2, "0")
  const month = String(d.getMonth() + 1).padStart(2, "0")
  const year = d.getFullYear()
  const hours24 = String(d.getHours()).padStart(2, "0")
  const minutes = String(d.getMinutes()).padStart(2, "0")
  const ampm = d.getHours() >= 12 ? "PM" : "AM"
  return `${day}/${month}/${year}, ${hours24}:${minutes} ${ampm}`
}
const getLatestTalentScanHistory = history => {
  if (!Array.isArray(history) || !history.length) return null
  const withData = history.filter(h => h?.response_data)
  if (!withData.length) return null
  return [...withData].sort((a, b) => {
    const aTime = new Date(a.completed_at || a.scheduled_at || a.sent_at || 0).getTime()
    const bTime = new Date(b.completed_at || b.scheduled_at || b.sent_at || 0).getTime()
    return bTime - aTime
  })[0]
}
const capitalizeFirst = str => {
  if (!str || str === "-") return str
  return str.replace(/\b\w/g, c => c.toUpperCase())
}

const textValue = value =>
  value === null || value === undefined || value === "" ? "-" : value

const asNumber = value => {
  const n = Number(value)
  return Number.isFinite(n) ? n : 0
}

const formatScore = value => {
  const n = asNumber(value)
  return Number.isInteger(n) ? String(n) : n.toFixed(2)
}

const formatPct = value => `${formatScore(value)}`

const formatTalentScanDate = value => {
  if (!value) return "-"
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) return value
  return parsed.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
}
function TelephonicTests() {
  document.title = "ATS - Telephonic Tests"
  const [activeTab, setActiveTab] = useState("telephonic")
  const [companyId, setCompanyId] = useState(null)
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false)
  const [jobList, setJobList] = useState([])
  const [jobsLoading, setJobsLoading] = useState(false)
  const [selectedJobId, setSelectedJobId] = useState("")
  const [searchTerm, setSearchTerm] = useState("")
  const [fromDate, setFromDate] = useState(todayStr())
  const [toDate, setToDate] = useState(todayStr())
  const [screeningStatus, setScreeningStatus] = useState("")
  const [talentScanType, setTalentScanType] = useState("all")
  const [jobTitleSearch, setJobTitleSearch] = useState("")
  const [jobTitlePage, setJobTitlePage] = useState(1)
  const [jobTitleTotalCount, setJobTitleTotalCount] = useState(0)
  const totalJobTitlePages = Math.max(1, Math.ceil(jobTitleTotalCount / 10))
  const SCREENING_STATUS_OPTIONS = [
  { value: "Completed", label: "Completed" },
  { value: "Call_attempted", label: "Call Attempted" },
  { value: "Initiated", label: "Initiated" },
  { value: "Call_back", label: "Call Back" },
  { value: "Not_answered", label: "Not Answered" },
  { value: "Rejected", label: "Rejected" },
]
  const TALENT_SCAN_TYPE_OPTIONS = [
    { value: "all", label: "All" },
    { value: "sent", label: "Sent" },
    { value: "scheduled", label: "Scheduled" },
    { value: "completed", label: "Completed" },
    { value: "not_attempted", label: "Not Attempted" },
  ]
  const [dateError, setDateError] = useState("")
  const [records, setRecords] = useState([])
  const [totalRows, setTotalRows] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [loading, setLoading] = useState(false)
  const [resultModal, setResultModal] = useState(false)
  const [resultData, setResultData] = useState(null)
  const [resultType, setResultType] = useState("")
  const [resultLoading, setResultLoading] = useState(false)
  const [resultError, setResultError] = useState("")
    useEffect(() => {
    setSearchTerm("")
  }, [])
  
  const [talentScanRecords, setTalentScanRecords] = useState([])
  const screeningCutOff = talentScanRecords?.[0]?.screening_percentage ?? null
  const [talentScanTotalRows, setTalentScanTotalRows] = useState(0)
  const [talentScanPerPage, setTalentScanPerPage] = useState(10)
  const [talentScanLoading, setTalentScanLoading] = useState(false)
  const [talentScanModal, setTalentScanModal] = useState(false)
  const [talentScanCandidate, setTalentScanCandidate] = useState(null)    
  const [talentScanResults, setTalentScanResults] = useState([])
  const [talentScanResultLoading, setTalentScanResultLoading] = useState(false)
  const [viewingTestResultMap, setViewingTestResultMap] = useState({})
  const [loadingResultMap, setLoadingResultMap] = useState({}) 
  const [scoreDetailsModal, setScoreDetailsModal] = useState(false)
  const [scoreDetailsCandidate, setScoreDetailsCandidate] = useState(null)
  const getCandidateTalentScanId = candidate =>
    candidate?.ts_candidate_id ??
    candidate?.talent_scan_id ??
    candidate?.talent_scan_candidate_id ??
    candidate?.talent_scan?.id
  const getCandidateJobId = candidate =>
    candidate?.job_id ??
    candidate?.job?.job_id ??
    candidate?.job?.id ??
    (selectedJobId ? Number(selectedJobId) : undefined)
  const getScoreRecordDate = record =>
    record?.completed_at ||
    record?.scheduled_at ||
    record?.sent_at ||
    record?.missed_at ||
    null
  const getLatestScoreRecord = records => {
    if (!Array.isArray(records) || !records.length) return null
    return [...records].sort((a, b) => {
      const aTime = new Date(getScoreRecordDate(a) || 0).getTime()
      const bTime = new Date(getScoreRecordDate(b) || 0).getTime()
      return bTime - aTime
    })[0]
  }
  const getLatestScoredRecord = records => {
    if (!Array.isArray(records) || !records.length) return null
    return [...records]
      .filter(record => record?.score !== null && record?.score !== undefined)
      .sort((a, b) => {
        const aTime = new Date(getScoreRecordDate(a) || 0).getTime()
        const bTime = new Date(getScoreRecordDate(b) || 0).getTime()
        return bTime - aTime
      })[0]
  }

  const getScoreRecordStatus = record => {
    if (!record) return "-"
    if (record.completed_at) return "Completed"
    if (record.missed_at) return "Missed"
    if (record.scheduled_at) return "Scheduled"
    if (record.sent_at) return "Sent"
    return capitalizeFirst(record.event_type || "-")
  }
  const getCandidateName = candidate => {
    const full = [
      candidate?.first_name,
      candidate?.middle_name,
      candidate?.last_name,
    ]
      .filter(Boolean)
      .join(" ")
    return (
      full ||
      candidate?.name ||
      candidate?.candidate_name ||
      candidate?.display_name ||
      "-"
    )
  }
  const getCandidateEmail = candidate =>
    candidate?.email ||
    candidate?.candidate_email ||
    candidate?.display_email ||
    "-"
  const getCandidatePhone = candidate =>
    candidate?.mobile_phone ||
    candidate?.phone ||
    candidate?.candidate_phone ||
    candidate?.display_phone ||
    "-"
  const fetchJobs = async (cid = companyId, page = 1, search = "") => {
  setJobsLoading(true)
  try {
    const { data } = await axios.get("/api/v1/create-job-order/", {
      params: {
        page,
        size: 10,
        company_id: cid,
        ...(search ? { search } : {}),
      },
    })
    const jobs =
      data?.results ||
      data?.data?.results ||
      (Array.isArray(data) ? data : [])
    setJobList(Array.isArray(jobs) ? jobs : [])
    setJobTitleTotalCount(data?.count || data?.data?.count || 0)
    setJobTitlePage(page)
  } catch (error) {
    console.error("Error fetching job orders:", error)
    setJobList([])
    setJobTitleTotalCount(0)
  } finally {
    setJobsLoading(false)
  }
}
useEffect(() => {
  if (!companyId) return
  setJobTitleSearch("")
  fetchJobs(companyId, 1, "")
}, [companyId])
  const handleScreeningStatusChange = val => {
    setScreeningStatus(val)
    if (activeTab === "telephonic") {
      fetchCallRecords(1, perPage, { screeningStatus: val })
    }
}
  const handleTalentScanTypeChange = val => {
    setTalentScanType(val)
    if (activeTab === "talentScan") {
      setResetPaginationToggle(prev => !prev)
      fetchTalentScanCandidates(1, talentScanPerPage, { talentScanType: val })
    }
  }
  const fetchCallRecords = async (page = 1, size = perPage, overrides = {}) => {
    const jobId =
      overrides.jobId !== undefined ? overrides.jobId : selectedJobId
    const search =
      overrides.search !== undefined ? overrides.search : searchTerm
    const fd = overrides.fromDate !== undefined ? overrides.fromDate : fromDate
    const td = overrides.toDate !== undefined ? overrides.toDate : toDate
    const status =
      overrides.screeningStatus !== undefined
        ? overrides.screeningStatus
        : screeningStatus
    if (fd && td && new Date(fd) > new Date(td)) {
      setDateError("From date cannot be after To date.")
      return
    }
    setDateError("")
    setLoading(true)
    try {
      const params = { page, size }
      if (companyId) params.company_id = companyId
      if (jobId) params.job_id = jobId
      if (search?.trim()) params.search = search.trim()
      if (fd) params.from_date = fd
      if (td) params.to_date = td
      if (status) params.screening_status = status
      const { data } = await axios.get("/api/v1/call-records/", { params })
      const apiData = data?.data || []
      const formattedData = apiData.map(item => {
        const primary = item.primary_evaluation || {}
        const secondary = item.secondary_evaluation || {}
        return {
          ...item,
          evaluation_id: primary?.id || secondary?.id,
          interview_round: primary?.id
            ? "primary"
            : secondary?.id
            ? "secondary"
            : "-",
          call_status: primary?.call_status || secondary?.call_status || "-",
        }
      })
      setRecords(formattedData)
      setTotalRows(data?.count || 0)
    } catch (error) {
      console.error("Error fetching call records:", error)
    } finally {
      setLoading(false)
    }
  }
  const skipNextJobEffect = useRef(false)
  useEffect(() => {
    if (!companyId) return
    if (skipNextJobEffect.current) {
      skipNextJobEffect.current = false
      return
    }
    if (activeTab === "telephonic") {
      fetchCallRecords(1, perPage)
    }
  }, [companyId, selectedJobId])
  useEffect(() => {
    if (!companyId) return
    const t = setTimeout(() => {
      if (activeTab === "telephonic") {
        fetchCallRecords(1, perPage)
      } else if (activeTab === "talentScan") {
        fetchTalentScanCandidates(1, talentScanPerPage)
      }
    }, 400)
    return () => clearTimeout(t)
  }, [searchTerm])

  const handleFromDateChange = val => {
    setFromDate(val)
    if (val && toDate && new Date(val) > new Date(toDate)) {
      setDateError("From date cannot be after To date.")
      return
    }
    setDateError("")
    setResetPaginationToggle(prev => !prev)   
    if (activeTab === "telephonic") {
      fetchCallRecords(1, perPage, { fromDate: val })
    } else if (activeTab === "talentScan") {
      fetchTalentScanCandidates(1, talentScanPerPage, { fromDate: val })
    }
  }

  const handleToDateChange = val => {
    setToDate(val)
    if (fromDate && val && new Date(fromDate) > new Date(val)) {
      setDateError("From date cannot be after To date.")
      return
    }
    setDateError("")
    setResetPaginationToggle(prev => !prev)   
    if (activeTab === "telephonic") {
      fetchCallRecords(1, perPage, { toDate: val })
    } else if (activeTab === "talentScan") {
      fetchTalentScanCandidates(1, talentScanPerPage, { toDate: val })
    }
  }
  const handleResetFilters = () => {
    skipNextJobEffect.current = true
    setSelectedJobId("")
    setSearchTerm("")
    setFromDate(todayStr())
    setToDate(todayStr())
    setScreeningStatus("")
    setTalentScanType("all")
    setDateError("")
    setTalentScanRecords([])
    setTalentScanTotalRows(0)
    setJobTitleSearch("")
    setJobTitlePage(1)
    setResetPaginationToggle(prev => !prev)  
    if (activeTab === "telephonic") {
      fetchCallRecords(1, perPage, {
        jobId: "",
        search: "",
        fromDate: todayStr(),
        toDate: todayStr(),
        screeningStatus: "",
      })
    } else if (activeTab === "talentScan") {
      fetchTalentScanCandidates(1, talentScanPerPage, {
        jobId: "",
        search: "",
        fromDate: todayStr(),
        toDate: todayStr(),
        talentScanType: "all",
      })
    }
  }

  const handlePageChange = page => fetchCallRecords(page, perPage)
  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage)
    fetchCallRecords(page, newPerPage)
  }
const fetchTalentScanCandidates = async (
    page = 1,
    size = talentScanPerPage,
    overrides = {}
  ) => {
    const jobId =
      overrides.jobId !== undefined ? overrides.jobId : selectedJobId
    const search =
      overrides.search !== undefined ? overrides.search : searchTerm
    const fd = overrides.fromDate !== undefined ? overrides.fromDate : fromDate
    const td = overrides.toDate !== undefined ? overrides.toDate : toDate
    const type =
      overrides.talentScanType !== undefined
        ? overrides.talentScanType
        : talentScanType

    if (!companyId || !jobId) {
      setTalentScanRecords([])
      setTalentScanTotalRows(0)
      return
    }

    if (fd && td && new Date(fd) > new Date(td)) {
      setDateError("From date cannot be after To date.")
      return
    }
    setDateError("")

    setTalentScanLoading(true)
    try {
      const params = { job_id: jobId, page, size: size }
      if (companyId) params.company_id = companyId
      if (search?.trim()) params.search = search.trim()
      params.type = type || "all"
      if (fd) params.from_date = fd
      if (td) params.to_date = td

      const { data } = await axios.get("/api/v1/candidate-scores/", {
        params,
      })

      const candidates = Array.isArray(data?.results) ? data.results : []
      const total = data?.count ?? candidates.length

      const normalized = candidates.map((c, idx) => {
        const scoreRecords = Array.isArray(c.score_records)
          ? c.score_records
          : []
        const latestRecord = getLatestScoreRecord(scoreRecords)
        const latestScoredRecord = getLatestScoredRecord(scoreRecords)
        const mappedScore =
          latestScoredRecord?.score ??
          c.secondary_score ??
          c.telephonic_score ??
          null
        const id =
          c.job_candidate_id ??
          c.candidate_job_id ??
          c.candidate_id ??
          c.id ??
          idx + 1

      const latestTsHistory = getLatestTalentScanHistory(c.talent_scan_history)
      const rawResponseData = latestTsHistory?.response_data || null
      const tsData = Array.isArray(rawResponseData?.results)
        ? rawResponseData.results[0] || null
        : rawResponseData
      const tsAtsDetails = tsData?.ats_details || {}

        return {
          ...c,
          job_candidate_id: id,
          candidate_id: c.candidate_id ?? c.ts_candidate_id ?? c.id ?? idx + 1,
          job_id: c.job_id ?? c.job?.job_id ?? c.job?.id ?? Number(jobId),
          talent_scan_id:
            c.ts_candidate_id ??
            c.talent_scan_candidate_id ??
            c.talent_scan_id ??
            c.talent_scan_candidate?.id ??
            null,
          ts_job_id: c.ts_job_id ?? c.talent_scan_job_id ?? null,
          display_name: getCandidateName(c),
          display_email: getCandidateEmail(c),
          display_phone: getCandidatePhone(c),
          secondary_score: mappedScore,
          score_records: scoreRecords,
          latest_score_record: latestRecord,
          latest_score_status: getScoreRecordStatus(latestRecord),
          latest_score_date: getScoreRecordDate(latestRecord),
          ts_total_secured:
            tsAtsDetails.total_score_secured ?? tsData?.total_candidate_score ?? null,
          ts_total_score:
            tsAtsDetails.actual_total_score ?? tsData?.total_test_score ?? null,
          ts_percentage:
            tsAtsDetails.percentage_score ?? tsData?.candidate_percentage_score ?? null,
          ts_qualified: tsAtsDetails.is_test_qualified ?? null,
          ts_sent_at: latestTsHistory?.sent_at ?? null,
          ts_created_at: tsData?.test_info?.created_at ?? null,
          ts_submitted_at: tsData?.submitted_at ?? null,
          ts_evaluated_at: tsData?.evaluated_at ?? null,
          ts_attempted_at: tsData?.attempted_at ?? null
        }
      })

      setTalentScanRecords(normalized)
      setTalentScanTotalRows(total)
    } catch (error) {
      console.error("Error fetching Talent Scan candidate scores:", error)
      setTalentScanRecords([])
      setTalentScanTotalRows(0)
    } finally {
      setTalentScanLoading(false)
    }
  }

  useEffect(() => {
    if (activeTab !== "talentScan") return
    if (!companyId || !selectedJobId) {
      setTalentScanRecords([])
      setTalentScanTotalRows(0)
      return
    }
    fetchTalentScanCandidates(1, talentScanPerPage, { search: "" })
  }, [activeTab, companyId, selectedJobId])
  useEffect(() => {
    if (activeTab !== "talentScan") return
    if (selectedJobId) return
    if (!jobList.length) return
    const firstId = jobList[0].id ?? jobList[0].job_id ?? ""
    if (firstId !== "") setSelectedJobId(String(firstId))
  }, [activeTab, jobList, selectedJobId])

  const handleTalentScanPageChange = page =>
    fetchTalentScanCandidates(page, talentScanPerPage)

  const handleTalentScanPerRowsChange = (newPerPage, page) => {
    setTalentScanPerPage(newPerPage)
    fetchTalentScanCandidates(page, newPerPage)
  }

  const handleOpenTalentScanResults = async candidate => {
    const talentScanId = getCandidateTalentScanId(candidate)
    const jobId = getCandidateJobId(candidate)

    if (!talentScanId || !jobId) return

    const rowKey = candidate.job_candidate_id ?? candidate.candidate_id
    setLoadingResultMap(cur => ({ ...cur, [rowKey]: true }))
    setTalentScanResultLoading(true)

    try {
      const response = await axios.post(
        "/api/v1/candidate-talent-scan-result/",
        { talent_scan_id: talentScanId, job_id: jobId },
        { params: { page: 1, size: 10, company_id: companyId } }
      )
      const results = response?.data?.talent_scan_result?.results || []

      if (!results.length) {
        setTalentScanResultLoading(false)
        Swal.fire({
          icon: "info",
          title: "No Test Attempted",
          text: "This candidate has not attempted any Talent Scan test yet.",
          confirmButtonColor: "#0c447c",
        })
        return
      }

      setTalentScanCandidate(candidate)
      setTalentScanResults(results)
      setTalentScanModal(true)
    } catch (error) {
      console.error("Failed to fetch candidate talent scan result", error)
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        text: "Failed to fetch Talent Scan result. Please try again.",
        confirmButtonColor: "#0c447c",
      })
    } finally {
      setTalentScanResultLoading(false)
      setLoadingResultMap(cur => ({ ...cur, [rowKey]: false }))
    }
  }
  const handleViewDetailedTalentResult = async test => {  
    if (test?.id == null || test?.attempt_id == null) return
    const key = `${test.id}-${test.attempt_id}`
    setViewingTestResultMap(cur => ({ ...cur, [key]: true }))
    try {
      const response = await axios.post(
        "/api/v1/ts-view-test/create-dashboard-link/",
        { assign_test_id: test.id, attempt_id: test.attempt_id }
      )
      if (response?.data?.url) window.open(response.data.url, "_blank")
    } catch (error) {
      console.error("Failed to generate Talent Scan detail link", error)
    } finally {
      setViewingTestResultMap(cur => ({ ...cur, [key]: false }))
    }
  }
  const handleViewFirstScreening = async row => {
    const id = row.primary_evaluation?.external_call_id
    if (!id) {
      console.warn("Primary evaluation ID missing")
      return
    }
    setResultType("First Screening")
    setResultData(null)
    setResultError("")
    setResultModal(true)
    setResultLoading(true)
    try {
      const { data } = await axios.get(
        `/api/v1/get-primary-evaluation/?id=${id}`
      )
      const evalData = data?.data || {}
      const transcript = data?.transcript || []
      const recording = data?.recording || ""
      const screeningQuestions = Object.entries(evalData)
        .filter(([key]) => /^\d+$/.test(key))
        .sort(([a], [b]) => Number(a) - Number(b))
        .map(([, value]) => value)

      setResultData({
        candidate_name: evalData["Candidate Name"] || row.candidate_name || "-",
        candidate_phone: evalData["Candidate Phone"] || row.phone || "-",
        agent_name: evalData["Agent Name"] || "-",
        job_title: row.job_title || "-",
        designation: row.designation || "-",
        date_of_interview: evalData.date_of_interview || "-",
        next_interview:
          evalData["Date And Time For Next Interview"] ||
          evalData["Next Interview Date Time"] ||
          "-",
        questions: screeningQuestions,
        transcript,
        recording,
      })
    } catch (error) {
      console.error("Error fetching primary evaluation:", error)
      setResultError(
        error?.response?.data?.message || "Failed to fetch evaluation data."
      )
      setResultData(null)
    } finally {
      setResultLoading(false)
    }
  }
  const handleViewSecondScreening = async row => {
    const id = row.secondary_evaluation?.external_call_id
    if (!id) {
      console.warn("Secondary evaluation ID missing")
      return
    }
    setResultType("Screening")
    setResultData(null)
    setResultError("")
    setResultModal(true)
    setResultLoading(true)
    try {
      const { data } = await axios.get(
        `/api/v1/get-secondary-evaluation/?id=${id}`
      )
      const evalData = data?.data || {}
      const transcript = data?.transcript || []
      const recording = data?.recording || ""

      setResultData({
        candidate_name:
          evalData["Candidate Name"] ||
          evalData.candidate_name ||
          row.candidate_name ||
          "-",
        candidate_phone: evalData["Candidate Phone"] || row.phone || "-",
        agent_name: evalData["Agent Name"] || evalData.agent_name || "-",
        job_title: evalData.job_position || row.job_title || "-",
        designation: row.designation || "-",
        date_of_interview: evalData.date_of_interview || "-",
        next_interview:
          evalData["Next Interview Date Time"] ||
          evalData.date_of_interview ||
          "-",
        questions: evalData["Questions"] || [],
        transcript,
        recording,
        sections: evalData.sections || null,
        overall_score: evalData.overall_score ?? null,
        key_strengths: evalData.key_strengths || "",
        overall_recommendation: evalData.overall_recommendation || "",
        priority_improvements: evalData.priority_improvements || "",
      })
    } catch (error) {
      console.error("Error fetching secondary evaluation:", error)
      setResultError(
        error?.response?.data?.message || "Failed to fetch evaluation data."
      )
      setResultData(null)
    } finally {
      setResultLoading(false)
    }
  }
  const avatarColors = [
    "#0d6efd",
    "#7c3aed",
    "#059669",
    "#d97706",
    "#dc2626",
    "#0891b2",
  ]

  const colorForName = name => {
    if (!name) return avatarColors[0]
    let hash = 0
    for (let i = 0; i < name.length; i++)
      hash = name.charCodeAt(i) + ((hash << 5) - hash)
    return avatarColors[Math.abs(hash) % avatarColors.length]
  }

  const initials = name => {
    if (!name || name === "-") return "?"
    return name
      .trim()
      .split(/\s+/)
      .map(w => w[0])
      .slice(0, 2)
      .join("")
      .toUpperCase()
  }

  const AvatarCell = ({ name, email, isLink, onClick }) => (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 8,
        width: "100%",
        height: 44,
        padding: "4px 0",
      }}
    >
      <div
        style={{
          width: 30,
          height: 30,
          minWidth: 30,
          borderRadius: "50%",
          background: colorForName(name),
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 12,
          fontWeight: 700,
          flexShrink: 0,
        }}
      >
        {initials(name)}
      </div>
      <div style={{ lineHeight: 1.3, minWidth: 0, textAlign: "left", flex: 1 }}>
        {isLink ? (
          <span
            title={name || "-"}
            style={{
              color: "#0d6efd",
              cursor: "pointer",
              textDecoration: "underline",
              fontWeight: 500,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "block",
              textAlign: "left",
            }}
            onClick={onClick}
            onMouseEnter={e => (e.target.style.color = "#0a58ca")}
            onMouseLeave={e => (e.target.style.color = "#0d6efd")}
          >
            {name || "-"}
          </span>
        ) : (
          <div
            title={name || "-"}
            style={{
              fontWeight: 600,
              color: "#1f2937",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textAlign: "left",
            }}
          >
            {name || "-"}
          </div>
        )}
        <div
          title={email || "-"}
          style={{
            fontSize: 12,
            color: "#6b7280",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "left",
          }}
        >
          {email || "-"}
        </div>
      </div>
    </div>
  )
  const getStatusBadge = status => {
    const statusMap = {
      initiated: { bg: "bg-info", label: "Initiated" },
      completed: { bg: "bg-success", label: "Completed" },
      failed: { bg: "bg-danger", label: "Failed" },
      sent_consent: { bg: "bg-warning", label: "Sent Consent" },
      in_progress: { bg: "bg-primary", label: "In Progress" },
    }
    const s = statusMap[status] || { bg: "bg-secondary", label: status || "-" }
    return <span className={`badge ${s.bg}`}>{s.label}</span>
  }

  const columns = [
    {
      name: <span className="telephonic-col-title">Recruiter Name</span>,
      selector: row => row.secondary_evaluation.hr_name || "-",
      sortable: true,
      width: "180px",
      grow: 0,
     cell: row => {
          const name =
            row.primary_evaluation?.hr_name ||
            row.secondary_evaluation?.hr_name ||
            "-";

          const email =
            row.primary_evaluation?.hr_email ||
            row.secondary_evaluation?.hr_email ||
            "-";

          return (
            <AvatarCell
              name={name}
              email={email}
            />
          );
        }
      },
    {
      name: <span className="telephonic-col-title">Candidate Name</span>,
      selector: row => row.candidate_name || "-",
      sortable: true,
      width: "200px",
      grow: 0,
      cell: row => (
        <AvatarCell name={row.candidate_name} email={row.candidate_email}  
        isLink
        onClick={() => {
          if (row.primary_evaluation?.id) {
            handleViewFirstScreening(row);
          } else if (row.secondary_evaluation?.id) {
            handleViewSecondScreening(row);
          }
        }} 
  />
      ),
    },
    {
      name: <span className="telephonic-col-title">Phone</span>,
      selector: row => row.phone || "-",
      sortable: true,
      width: "130px",
      grow: 0,
      cell: row => <span title={row.phone || "-"}>{row.phone || "-"}</span>,
    },
    {
      name: <span className="telephonic-col-title">Designation</span>,
      selector: row => row.designation || "-",
      sortable: true,
      minWidth: "150px",
      grow: 1,
      cell: row => (
        <span title={row.designation || "-"}>{row.designation || "-"}</span>
      ),
    },
    {
      name: <span className="telephonic-col-title">Job Title</span>,
      selector: row => row.job_title || "-",
      sortable: true,
      minWidth: "180px",
      grow: 1.2,
      cell: row => (
        <span title={row.job_title || "-"}>{row.job_title || "-"}</span>
      ),
    },
    {
      name: <span className="telephonic-col-title">Screening Status</span>,
      minWidth: "150px",
      grow: 1,
      cell: row =>
        row.secondary_evaluation?.call_status
          ? row.secondary_evaluation.call_status
          : "-",
    },
    {
      name: <span className="telephonic-col-title">Screening Score</span>,
      minWidth: "150px",
      grow: 1,
      cell: (row) =>
        row.secondary_evaluation?.score != null
          ? `${(row.secondary_evaluation.score)}/10`
          : "-",
    },
    {
      name: <span className="telephonic-col-title">Scheduled Time</span>,
      selector: row => row.created_at,
      sortable: true,
      minWidth: "160px",
      grow: 1,
      cell: row => (
        <span title={formatDateTime(row.created_at)}>
          {formatDateTime(row.created_at)}
        </span>
      ),
    },
    {
      name: <span className="telephonic-col-title">Action</span>,
      minWidth: "220px",
      grow: 1.2,
      cell: row => {
        const hasPrimary = row.primary_evaluation?.id
        const hasSecondary = row.secondary_evaluation?.id
        const buttonCount = [hasPrimary, hasSecondary].filter(Boolean).length
        return (
          <div
            className="d-flex align-items-center flex-wrap gap-1"
            style={{
              justifyContent: buttonCount === 1 ? "center" : "flex-start",
              width: "100%",
            }}
          >
            {hasPrimary && (
              <Button
                size="sm"
                variant="outline-primary"
                onClick={() => handleViewFirstScreening(row)}
              >
                First Screening Result
              </Button>
            )}
            {hasSecondary && (
              <Button
                size="sm"
                variant="outline-success"
                onClick={() => handleViewSecondScreening(row)}
              >
                Screening Result
              </Button>
            )}
          </div>
        )
      },
    },
  ]
  const talentScanColumns = [
    {
      name: <span className="telephonic-col-title">Candidate Name</span>,
      selector: row => row.display_name || "-",
      sortable: true,
      minWidth: "190px",
      grow: 1,
      cell: row => {
        const talentScanId = getCandidateTalentScanId(row)
        const jobId = getCandidateJobId(row)

        return (
          <AvatarCell
            name={row.display_name}
            email={row.display_email}
            isLink={!!talentScanId && !!jobId}
            onClick={() => {
              if (talentScanId && jobId) handleOpenTalentScanResults(row)
            }}
          />
        )
      },
    },
    {
      name: <span className="telephonic-col-title">Email</span>,
      selector: row => row.display_email || "-",
      sortable: true,
      minWidth: "190px",
      grow: 1,
      cell: row => (
        <span title={row.display_email || "-"}>{row.display_email || "-"}</span>
      ),
    },
    {
      name: <span className="telephonic-col-title">Phone</span>,
      selector: row => row.display_phone || "-",
      sortable: true,
      minWidth: "190px",
      grow: 1,
      cell: row => (
        <span title={row.display_phone || "-"}>{row.display_phone || "-"}</span>
      ),
    },
  {
      name: <span className="telephonic-col-title">Telephonic Score</span>,
      selector: row => row.secondary_score ?? "-",
      sortable: true,
      minWidth: "190px",
      grow: 1,
      center: true,
      cell: row => {
        const score = row.secondary_score;
        const hasScore =
          score !== null && score !== undefined && score !== "-";
        const recordCount = Array.isArray(row.score_records)
          ? row.score_records.length
          : 0;
        const latestRecord = row.latest_score_record;
        const latestStatus = getScoreRecordStatus(latestRecord);
        const latestDate = getScoreRecordDate(latestRecord);

        const openDetails = () => {
          setScoreDetailsCandidate(row);
          setScoreDetailsModal(true);
        };

        if (!hasScore) {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
                width: "100%",
              }}
            >
              <span
                style={{
                  cursor: recordCount ? "pointer" : "default",
                  textDecoration: recordCount ? "underline" : "none",
                }}
                onClick={recordCount ? openDetails : undefined}
                title={recordCount ? "View attempt history" : undefined}
              >
                -
              </span>
            </div>
          );
        }

        const numScore = Number(score);
        const displayScore = Number.isFinite(numScore)
           ? `${Number(numScore).toFixed(1)}/10`
          : score;

        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              width: "100%",
            }}
          >
            <span
              style={{
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={openDetails}
              title="View attempt history"
            >
              {displayScore}
            </span>
          </div>
        );
      },
    },
    {
      name: <span className="telephonic-col-title">Talent Scan Score</span>,
      selector: row => row.ts_percentage ?? "-",
      sortable: true,
      minWidth: "180px",
      grow: 1,
      center: true,
      cell: row => {
        const hasTsScore =
          row.ts_total_secured !== null && row.ts_total_secured !== undefined;

        if (!hasTsScore) {
          return <span>-</span>;
        }

        return (
          <span>
            {formatScore(row.ts_total_secured)} / {formatScore(row.ts_total_score)}
          </span>
        );
      },
    },
  //  {
  //     name: <span className="telephonic-col-title">Test Timeline</span>,
  //     selector: row => row.ts_submitted_at || row.ts_sent_at || "-",
  //     sortable: true,
  //     minWidth: "250px",
  //     grow: 1.3,
  //     cell: row => {
  //     const items = [
  //       { label: "Sent", value: row.ts_sent_at, color: "#94a3b8" },
  //       { label: "Created", value: row.ts_created_at, color: "#06b6d4" },
  //       { label: "Attempted", value: row.ts_attempted_at, color: "#f59e0b" },
  //       { label: "Submitted", value: row.ts_submitted_at, color: "#8b5cf6" },
  //       { label: "Evaluated", value: row.ts_evaluated_at, color: "#10b981" },
  //     ].filter(i => i.value)

  //     if (!items.length) {
  //       return <span style={{ color: "#cbd5e1", fontSize: 13 }}>—</span>
  //     }

  //     return (
  //       <div
  //         style={{
  //           background: "#f8fafc",
  //           border: "1px solid #eef2f7",
  //           borderRadius: 10,
  //           padding: "8px 10px",
  //           margin: "6px 0",
  //           width: "fit-content",
  //           minWidth: 200,
  //         }}
  //       >
  //         {items.map((item, idx) => (
  //           <div
  //             key={item.label}
  //             style={{
  //               display: "flex",
  //               alignItems: "center",
  //               gap: 8,
  //               padding: "3px 0",
  //               borderBottom:
  //                 idx !== items.length - 1 ? "1px dashed #e2e8f0" : "none",
  //             }}
  //           >
  //             <span
  //               style={{
  //                 width: 7,
  //                 height: 7,
  //                 borderRadius: "50%",
  //                 background: item.color,
  //                 flexShrink: 0,
  //                 boxShadow: `0 0 0 3px ${item.color}22`,
  //               }}
  //             />
  //             <span
  //               style={{
  //                 fontSize: 10.5,
  //                 fontWeight: 700,
  //                 color: "#64748b",
  //                 textTransform: "uppercase",
  //                 letterSpacing: 0.4,
  //                 minWidth: 66,
  //               }}
  //             >
  //               {item.label}
  //             </span>
  //             <span
  //               style={{
  //                 fontSize: 12,
  //                 fontWeight: 600,
  //                 color: "#1e293b",
  //                 whiteSpace: "nowrap",
  //               }}
  //             >
  //               {formatTalentScanDate(item.value)}
  //             </span>
  //           </div>
  //         ))}
  //       </div>
  //     )
  //   },
    // },
    // {
    //   name: <span className="telephonic-col-title">Latest Attempt</span>,
    //   selector: row => row.latest_score_date || "-",
    //   sortable: true,
    //   minWidth: "190px",
    //   cell: row => (
    //     <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
    //       <span style={{ fontWeight: 600 }}>
    //         {row.latest_score_status || "-"}
    //       </span>
    //       <span style={{ fontSize: 12, color: "#64748b" }}>
    //         {formatTalentScanDate(row.latest_score_date)}
    //       </span>
    //     </div>
    //   ),
    // },
    // {
    //   name: <span className="telephonic-col-title">Attempts</span>,
    //   selector: row => row.score_records?.length || 0,
    //   sortable: true,
    //   width: "130px",
    //   cell: row => (
    //     <Button
    //       size="sm"
    //       variant="outline-secondary"
    //       disabled={!row.score_records?.length}
    //       onClick={() => {
    //         setScoreDetailsCandidate(row)
    //         setScoreDetailsModal(true)
    //       }}
    //     >
    //       {row.score_records?.length || 0} Details
    //     </Button>
    //   ),
    // },
    {
      name: <span className="telephonic-col-title">Action</span>,
      minWidth: "190px",
      grow: 1,
      cell: row => {
        const talentScanId = getCandidateTalentScanId(row)
        const jobId = getCandidateJobId(row)
        const rowKey = row.job_candidate_id ?? row.candidate_id
        const isLoading = !!loadingResultMap[rowKey]
        return (
          <Button
            size="sm"
            variant="outline-primary"
            disabled={!talentScanId || !jobId || isLoading}
            onClick={() => handleOpenTalentScanResults(row)}
          >
            {isLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                />
                Loading...
              </>
            ) : (
              "View Result"
            )}
          </Button>
        )
      },
    },
  ]
const renderScoreDetailsModal = () => {
  const candidate = scoreDetailsCandidate || {}
  const records = Array.isArray(candidate.score_records)
    ? [...candidate.score_records]
        .filter(r => getScoreRecordStatus(r) === "Completed")
        .sort((a, b) => {
          const aTime = new Date(getScoreRecordDate(a) || 0).getTime()
          const bTime = new Date(getScoreRecordDate(b) || 0).getTime()
          return bTime - aTime
        })
    : []

  const statusStyle = status => {
    switch (status) {
      case "Completed":
        return { color: "#15803d", bg: "#dcfce7", border: "#a7f3d0" }
      case "Missed":
        return { color: "#dc2626", bg: "#fee2e2", border: "#fecaca" }
      case "Scheduled":
        return { color: "#d97706", bg: "#fef3c7", border: "#fde68a" }
      case "Sent":
        return { color: "#2563eb", bg: "#dbeafe", border: "#bfdbfe" }
      default:
        return { color: "#475467", bg: "#f1f5f9", border: "#e2e8f0" }
    }
  }
  const timelineSteps = record => [
    { label: "Sent", value: record.sent_at },
    { label: "Scheduled", value: record.scheduled_at },
    { label: "Completed", value: record.completed_at },
    { label: "Missed", value: record.missed_at },
  ].filter(step => step.value)

  return (
    <Modal
      show={scoreDetailsModal}
      onHide={() => setScoreDetailsModal(false)}
      size="lg"
      centered
      scrollable
    >
      <Modal.Header
        closeButton
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "#fff",
          border: "none",
          padding: "18px 24px",
        }}
      >
        <Modal.Title>
          <div className="d-flex align-items-center gap-2" style={{ fontSize: 17, fontWeight: 700 }}>
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: 8,
                background: "rgba(255,255,255,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Phone size={16} />
            </div>
            Telephonic Attempt History
          </div>
          <div style={{ fontSize: 12, color: "rgba(255,255,255,0.85)", fontWeight: 500, marginTop: 4 }}>
            {candidate.display_name || "-"} · {candidate.display_email || "-"} · {candidate.display_phone || "-"}
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: "#f8fafc", padding: 20 }}>
        {records.length ? (
          <div className="d-flex flex-column" style={{ gap: 12 }}>
            {records.map((record, index) => {
              const status = getScoreRecordStatus(record)
              const s = statusStyle(status)
              const hasScore = record.score !== null && record.score !== undefined
              const scoreColor =
                hasScore && record.score >= 7 ? "#15803d" : hasScore && record.score >= 5 ? "#d97706" : "#dc2626"
              const scoreBg =
                hasScore && record.score >= 7 ? "#dcfce7" : hasScore && record.score >= 5 ? "#fef3c7" : "#fee2e2"
              const steps = timelineSteps(record)

              return (
                <div
                  key={record.event_log_id || index}
                  style={{
                    background: "#fff",
                    borderRadius: 14,
                    border: "1px solid #e5e7eb",
                    padding: "16px 18px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
                  }}
                >
                  <div className="d-flex align-items-center justify-content-between flex-wrap mb-3" style={{ gap: 8 }}>
                    <div className="d-flex align-items-center" style={{ gap: 10 }}>
                      <div
                        style={{
                          width: 30,
                          height: 30,
                          borderRadius: "50%",
                          background: "linear-gradient(135deg, #667eea, #764ba2)",
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: 12,
                          fontWeight: 700,
                          flexShrink: 0,
                        }}
                      >
                        {records.length - index}
                      </div>
                      <div>
                        <div style={{ fontWeight: 700, fontSize: 13, color: "#1f2937" }}>
                          {capitalizeFirst(record.event_type || "-")} attempt
                        </div>
                        <div style={{ fontSize: 11, color: "#9ca3af" }}>
                          Event ID #{textValue(record.event_log_id)}
                        </div>
                      </div>
                    </div>

                    <div className="d-flex align-items-center" style={{ gap: 8 }}>
                      <span
                        className="badge"
                        style={{
                          background: s.bg,
                          color: s.color,
                          border: `1px solid ${s.border}`,
                          fontWeight: 700,
                          fontSize: 11,
                          padding: "5px 12px",
                          borderRadius: 999,
                        }}
                      >
                        {status}
                      </span>
                      <span
                        className="badge"
                        style={{
                          background: hasScore ? scoreBg : "#f1f5f9",
                          color: hasScore ? scoreColor : "#94a3b8",
                          fontWeight: 700,
                          fontSize: 12,
                          padding: "5px 12px",
                          borderRadius: 999,
                        }}
                      >
                        {hasScore ? `${formatScore(record.score)}/10` : "No score"}
                      </span>
                    </div>
                  </div>
                  {steps.length ? (
                    <div
                      className="d-flex flex-wrap"
                      style={{ gap: 10, paddingTop: 10, borderTop: "1px solid #f1f5f9" }}
                    >
                      {steps.map(step => (
                        <div
                          key={step.label}
                          style={{
                            flex: "1 1 120px",
                            background: "#f8fafc",
                            borderRadius: 10,
                            padding: "8px 10px",
                          }}
                        >
                          <div
                            style={{
                              fontSize: 10,
                              fontWeight: 700,
                              color: "#9ca3af",
                              textTransform: "uppercase",
                              letterSpacing: 0.5,
                              marginBottom: 2,
                            }}
                          >
                            {step.label}
                          </div>
                          <div style={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>
                            {formatTalentScanDate(step.value)}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div style={{ fontSize: 12, color: "#9ca3af", paddingTop: 8 }}>No timestamps recorded.</div>
                  )}
                </div>
              )
            })}
          </div>
        ) : (
          <div className="text-center text-muted py-5">No telephonic score records found.</div>
        )}
      </Modal.Body>

      <Modal.Footer className="justify-content-center" style={{ background: "#fff", borderTop: "1px solid #f0f0f0" }}>
        <Button
          variant="secondary"
          className="btn btn-primary blueBtn"
          style={{ borderRadius: 10, padding: "9px 32px", fontWeight: 600, fontSize: 13 }}
          onClick={() => setScoreDetailsModal(false)}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
  const renderTalentScanResultModal = () => {
    const candidateName =
      talentScanResults?.[0]?.candidate_info?.name ||
      talentScanCandidate?.display_name ||
      "-"
    const candidateEmail =
      talentScanResults?.[0]?.candidate_info?.email ||
      talentScanCandidate?.display_email ||
      "-"
    const candidatePhone =
      talentScanResults?.[0]?.candidate_info?.phone ||
      talentScanCandidate?.display_phone ||
      "-"
    return (
      <Modal
        show={talentScanModal}
        onHide={() => setTalentScanModal(false)}
        size="xl"
        centered
        scrollable
        className="test-result-modal"
      >
        <Modal.Header closeButton className="test-result-modal-header">
          <Modal.Title>
            <div className="test-result-modal-heading">
              <div className="test-result-modal-title">Talent Scan Result</div>
              <div className="test-result-modal-candidate-contact">
                {candidateName} | {candidateEmail} | {candidatePhone}
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="test-result-modal-body">
          {talentScanResultLoading ? (
            <OrgTableShimmer columns={7} rows={4} titleWidth="180px" />
          ) : talentScanResults.length ? (
            <div className="ts-result-list d-flex flex-column">
              {talentScanResults.map((test, index) => {
                const testInfo = test?.test_info || {}
                const candidateInfo = test?.candidate_info || {}
                const atsDetails = test?.ats_details || {}
                const sectionScores = Array.isArray(test?.score_info)
                  ? test.score_info
                  : []
                const totalSecured =
                atsDetails.total_score_secured ??
                  test.total_candidate_score ??
                  0
                const actualTotal =
                  atsDetails.actual_total_score ?? test.total_test_score ?? 0
                const overallPct =
                atsDetails.percentage_score ??
                  test.candidate_percentage_score ??
                  0
                const qualified = !!atsDetails.is_test_qualified
                const detailKey = `${test?.id}-${test?.attempt_id}`
                const canViewResult =
                  test?.id != null && test?.attempt_id != null
                  const isCheated = !!testInfo.is_cheated
                  const cheatedSection = testInfo.cheated_section || null
                const pctNumber = asNumber(overallPct)
                const scoreTone =
                  pctNumber >= 70 ? "good" : pctNumber >= 50 ? "mid" : "low"
                const telephonicScore =
                  talentScanCandidate?.secondary_score != null &&
                  talentScanCandidate?.secondary_score !== "-"
                    ? `${talentScanCandidate.secondary_score}/10`
                    : "-"

                return (
                  <div
                    key={`${test?.id || index}-${test?.attempt_id || index}`}
                    className="ts-result-shell"
                  >
                    <div className="ts-result-header">
                      <div className="ts-result-header-main">
                        <div className="ts-result-title">
                          {textValue(testInfo.name)}
                        </div>
                        <div className="ts-result-subtitle">
                          <span>{textValue(testInfo.test_designation)}</span>
                        </div>
                      </div>
                      <div className="ts-result-header-badges d-flex align-items-center gap-2">
                            <span
                              className={`ts-result-badge ${
                                qualified ? "success" : "danger"
                              }`}
                            >
                              {qualified ? "Qualified" : "Not qualified"}
                            </span>
                            {isCheated && (
                              <span
                                className="ts-result-badge"
                                style={{
                                  background: "#fee2e2",
                                  color: "#b91c1c",
                                  border: "1px solid #fca5a5",
                                  fontWeight: 700,
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: 4,
                                }}
                              >
                                <AlertCircle size={12} />
                                Cheating detected{cheatedSection ? `: ${cheatedSection}` : ""}
                              </span>
                            )}
                          </div>
                    </div>

                    <div className="ts-result-content d-flex flex-column">
                      <div className="ts-result-metrics"  style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(4, 1fr)",
                            gap: 12,
                          }}>
                         <div className="ts-result-metric info">
                          <div className="ts-result-metric-val">
                            {formatScore(totalSecured)} / {formatScore(actualTotal)}
                          </div>
                          <div className="ts-result-metric-label">
                            Secured / Actual
                          </div>
                        </div>
                        <div className={`ts-result-metric ${scoreTone}`}>
                          <div className="ts-result-metric-val">
                            {formatPct(overallPct)}%
                          </div>
                          <div className="ts-result-metric-label">
                            Overall percentage
                          </div>
                        </div>
                         <div className={`ts-result-metric ${qualified ? "good" : "low"}`}>
                            <div className="ts-result-metric-val">
                              {qualified ? "Qualified" : "Not Qualified"}
                            </div>
                            <div className="ts-result-metric-label">
                              Qualification 
                            </div>
                          </div>
                        <div className="ts-result-metric neutral">
                          <div className="ts-result-metric-val">
                            {telephonicScore}
                          </div>
                          <div className="ts-result-metric-label">
                            Telephonic score
                          </div>
                        </div>
                      </div>

                      <Row className="g-3 mb-3">
                        <Col lg={6}>
                          <div className="ts-result-card ts-result-info-table h-100">
                            <div className="ts-result-info-table-heading">
                              Candidate information
                            </div>
                            <div className="ts-result-grid-2">
                              {[
                                {
                                  label: "Name",
                                  value: candidateInfo.name || candidateName,
                                },
                                {
                                  label: "Email",
                                  value: candidateInfo.email || candidateEmail,
                                },
                                {
                                  label: "Phone",
                                  value: candidateInfo.phone || candidatePhone,
                                },
                                {
                                  label: "Experience",
                                  value:
                                    candidateInfo.experience !== null &&
                                    candidateInfo.experience !== undefined
                                      ? `${candidateInfo.experience} yrs`
                                      : "-",
                                },
                              ].map(item => (
                                <div className="ts-result-kv-row" key={item.label}>
                                  <span className="ts-result-kv-key">
                                    {item.label}
                                  </span>
                                  <span className="ts-result-kv-val">
                                    {textValue(item.value)}
                                  </span>
                                </div>
                              ))}
                            </div>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="ts-result-card ts-result-info-table h-100">
                            <div className="ts-result-info-table-heading">
                              Test timeline
                            </div>
                            <div className="ts-result-grid-2">
                              {[
                                {
                                  label: "Attempted",
                                  value: formatTalentScanDate(test.attempted_at),
                                },
                                {
                                  label: "Submitted",
                                  value: formatTalentScanDate(test.submitted_at),
                                },
                                {
                                  label: "Evaluated",
                                  value: formatTalentScanDate(test.evaluated_at),
                                },
                                {
                                  label: "Attempt ID",
                                  value: test.attempt_id,
                                },
                              ].map(item => (
                                <div className="ts-result-kv-row" key={item.label}>
                                  <span className="ts-result-kv-key">
                                    {item.label}
                                  </span>
                                  <span className="ts-result-kv-val">
                                    {textValue(item.value)}
                                  </span>
                                </div>
                              ))}
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <div className="ts-result-card">
                        <div className="d-flex align-items-center justify-content-between gap-3 mb-2 flex-wrap">
                          <div>
                            <div className="ts-result-section-label mb-1">
                              Section scores
                            </div>
                            <div style={{ color: "#667085", fontSize: 12 }}>
                              Score split by section and qualification status
                            </div>
                          </div>
                          <span className="ts-result-badge neutral">
                            {sectionScores.length} section
                            {sectionScores.length === 1 ? "" : "s"}
                          </span>
                        </div>
                        <div className="table-responsive">
                          <table className="table table-sm table-bordered align-middle mb-0">
                            <thead className="table-light">
                              <tr>
                                <th className="text-center">Section</th>
                                <th className="text-center">Questions</th>
                                <th className="text-center">Attempted</th>
                                <th className="text-center">Total</th>
                                <th className="text-center">Cutoff</th>
                                <th className="text-center">Secured</th>
                                <th className="text-center">Score %</th>
                                <th className="text-center">Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {sectionScores.length ? (
                                sectionScores.map((section, idx) => {
                                  const sectionPct = asNumber(section.percentage)
                                  const sectionTone =
                                    sectionPct >= 70
                                      ? "good"
                                      : sectionPct >= 50
                                      ? "mid"
                                      : "low"
                                  const isCheatedRow =
                                    isCheated && section.section__name === cheatedSection

                                  return (
                                    <tr
                                      key={`${section.section__name}-${idx}`}
                                      style={
                                        isCheatedRow
                                          ? {
                                              background: "#fef2f2",
                                              boxShadow: "inset 0 0 0 9999px rgba(220,38,38,0.04)",
                                            }
                                          : undefined
                                      }
                                    >
                                      <td
                                        style={{
                                          fontWeight: 700,
                                          color: isCheatedRow ? "#b91c1c" : undefined,
                                        }}
                                        className="text-center"
                                      >
                                        {textValue(section.section__name)}
                                        {isCheatedRow && (
                                          <div
                                            style={{
                                              fontSize: 10,
                                              fontWeight: 700,
                                              color: "#dc2626",
                                              textTransform: "uppercase",
                                              letterSpacing: 0.4,
                                            }}
                                          >
                                            Cheated
                                          </div>
                                        )}
                                      </td>
                                      <td className="text-center">{textValue(section.no_of_questions)}</td>
                                      <td className="text-center">
                                        {textValue(section.no_of_questions_attempted)}
                                      </td>
                                      <td className="text-center">{textValue(section.total_score)}</td>
                                      <td className="text-center">{textValue(section.cutoff_score)}</td>
                                      <td className="text-center">{textValue(section.score_secured)}</td>
                                      <td className="text-center">
                                        <span className={`ts-result-score-pill ${sectionTone}`}>
                                          {formatPct(section.percentage)}
                                        </span>
                                      </td>
                                      <td className="text-center">
                                        <span
                                          className={`ts-result-badge ${
                                            section.is_qualified ? "success" : "neutral"
                                          }`}
                                        >
                                          {section.is_qualified ? "Qualified" : "Not qualified"}
                                        </span>
                                      </td>
                                    </tr>
                                  )
                                })
                              ) : (
                                <tr>
                                  <td
                                    colSpan="8"
                                    className="text-center text-muted py-4"
                                  >
                                    No section scores found.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {canViewResult && (
                        <div className="ts-result-actions">
                          <Button
                            size="sm"
                            className="ts-result-detail-btn"
                            disabled={!!viewingTestResultMap[detailKey]}
                            onClick={() => handleViewDetailedTalentResult(test)}
                          >
                            {viewingTestResultMap[detailKey]
                              ? "Opening..."
                              : "View Detailed Result"}
                          </Button>
                        </div>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          ) : (
            <div className="ts-result-empty">
              <div className="ts-result-empty-icon">i</div>
              <div className="ts-result-empty-title">No Talent Scan result</div>
              <div className="ts-result-empty-copy">
                This candidate has not been assigned any Talent Scan tests yet.
              </div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer className="test-result-modal-footer justify-content-center">
          <Button
            variant="secondary"
            className="btn btn-md blueBtn"
            onClick={() => setTalentScanModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
 const handleCompanyChange = c => {
  if (c?.company_id) {
    setCompanyId(c.company_id)
    setSelectedJobId("")
    setJobList([])
    setJobTitleSearch("")
    setJobTitlePage(1)
    setJobTitleTotalCount(0)
    setTalentScanRecords([])
    setTalentScanTotalRows(0)
  }
}
  const renderResultModal = () => (
    <>
      <style>{screeningModalStyles}</style>
      <Modal
        show={resultModal}
        onHide={() => setResultModal(false)}
        size="xl"
        centered
        className="screening-modal"
        backdrop="static"
      >
        <Modal.Header
          closeButton
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            color: "#fff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title
            className="d-flex align-items-center gap-2"
            style={{ fontSize: 18, fontWeight: 600 }}
          >
            <div
              style={{
                width: 34,
                height: 34,
                borderRadius: 8,
                background: "rgba(255,255,255,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backdropFilter: "blur(4px)",
              }}
            >
              <Phone size={18} />
            </div>
            {resultType} Result
            {resultData && !resultError && (
              <Badge
                pill
                bg="light"
                text="dark"
                style={{ fontSize: 11, fontWeight: 500, marginLeft: 8 }}
              >
                <Sparkles size={12} className="me-1" />
                AI Screening
              </Badge>
            )}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: 0, maxHeight: "78vh" }}>
          {resultLoading ? (
            <div
              className="text-center py-5"
              style={{ animation: "fadeIn 0.3s ease" }}
            >
              <div
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #667eea, #764ba2)",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  animation: "pulse 1.5s ease infinite",
                  marginBottom: 16,
                }}
              >
                <Phone size={28} style={{ color: "#fff" }} />
              </div>
              <h6 className="text-muted mb-1">Loading screening results…</h6>
              <div
                className="mx-auto mt-3"
                style={{
                  width: 200,
                  height: 4,
                  borderRadius: 2,
                  background: "#e5e7eb",
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    width: "40%",
                    height: "100%",
                    borderRadius: 2,
                    background:
                      "linear-gradient(90deg, #667eea, #764ba2, #667eea)",
                    backgroundSize: "200% 100%",
                    animation: "shimmer 1.5s ease infinite",
                  }}
                />
              </div>
            </div>
          ) : resultError ? (
            <div
              className="text-center py-5 px-3"
              style={{ animation: "fadeInUp 0.4s ease" }}
            >
              <div
                style={{
                  width: 90,
                  height: 90,
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #fef2f2, #fee2e2)",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginBottom: 20,
                  boxShadow: "0 8px 24px rgba(220,53,69,0.15)",
                }}
              >
                <Phone size={40} style={{ color: "#dc3545" }} />
              </div>
              <h5 className="text-danger mb-2" style={{ fontWeight: 600 }}>
                {resultError}
              </h5>
            </div>
          ) : resultData ? (
            <div className="screening-split-body" style={{ maxHeight: "78vh" }}>
              {/* LEFT PANE */}
              <div className="screening-details-pane">
                <div style={{ animation: "fadeIn 0.4s ease" }}>
                  <Row>
                    <Col md={6}>
                      <div
                        className="d-flex align-items-center gap-3 mb-3 screening-avatar-candidate"
                        style={{ animation: "slideInLeft 0.5s ease forwards" }}
                      >
                        <div
                          style={{
                            width: 52,
                            height: 52,
                            borderRadius: "50%",
                            background:
                              "linear-gradient(135deg, #667eea, #764ba2)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                            fontSize: 22,
                            fontWeight: 700,
                            flexShrink: 0,
                            boxShadow: "0 4px 14px rgba(102,126,234,0.4)",
                          }}
                        >
                          {(resultData.candidate_name || "C")[0].toUpperCase()}
                        </div>
                        <div>
                          <h6
                            className="mb-0"
                            style={{ fontWeight: 700, fontSize: 15 }}
                          >
                            {capitalizeFirst(resultData.candidate_name)}
                          </h6>
                          <small
                            className="text-muted"
                            style={{ fontSize: 12 }}
                          >
                            {capitalizeFirst(
                              resultData.designation || resultData.job_title
                            )}
                          </small>
                        </div>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div
                        className="d-flex align-items-center gap-3 mb-3 screening-avatar-candidate"
                        style={{ animation: "slideInRight 0.5s ease forwards" }}
                      >
                        <div
                          style={{
                            width: 52,
                            height: 52,
                            borderRadius: "50%",
                            background:
                              "linear-gradient(135deg, #f093fb, #f5576c)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                            flexShrink: 0,
                            boxShadow: "0 4px 14px rgba(240,147,251,0.4)",
                          }}
                        >
                          <Bot size={24} />
                        </div>
                        <div>
                          <h6
                            className="mb-0"
                            style={{ fontWeight: 700, fontSize: 15 }}
                          >
                            {capitalizeFirst(resultData.agent_name)}
                          </h6>
                          <small style={{ fontSize: 12, color: "#f5576c" }}>
                            AI Recruiter
                          </small>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    {[
                      {
                        icon: <Phone size={16} />,
                        label: "Phone",
                        value: resultData.candidate_phone,
                        color: "#0d6efd",
                        bg: "#eff6ff",
                      },
                      {
                        icon: <Briefcase size={16} />,
                        label: "Designation",
                        value: capitalizeFirst(resultData.job_title),
                        color: "#059669",
                        bg: "#ecfdf5",
                      },
                      {
                        icon: <Calendar size={16} />,
                        label: "Interview End Time",
                        value:
                          resultData.date_of_interview &&
                          resultData.date_of_interview !== "-"
                            ? convertISTtoEST(resultData.date_of_interview)
                            : "-",
                        color: "#7c3aed",
                        bg: "#f5f3ff",
                      },
                      ...(resultType !== "Screening"
                        ? [
                            {
                              icon: <Calendar size={16} />,
                              label: "Next Interview",
                              value:
                                resultData.next_interview &&
                                resultData.next_interview !== "-"
                                  ? formatDateTime(resultData.next_interview)
                                  : "-",
                              color: "#7c3aed",
                              bg: "#f5f3ff",
                            },
                          ]
                        : []),
                      ...(resultType === "Screening" &&
                      resultData.overall_score !== null &&
                      resultData.overall_score !== undefined
                        ? [
                            {
                              icon: <Star size={16} />,
                              label: "Overall Score",
                              value: `${resultData.overall_score}/10`,
                              color: "#2563eb",
                              bg: "#eff6ff",
                              highlight: true,
                            },
                          ]
                        : []),
                    ].map((item, idx) => (
                      <Col md={6} key={idx}>
                        <div
                          className="d-flex align-items-center gap-2 mb-3 screening-info-card"
                          style={{
                            background: item.highlight
                              ? "linear-gradient(135deg, #eff6ff, #dbeafe)"
                              : "#fff",
                            borderRadius: 10,
                            padding: "12px 14px",
                            border: item.highlight
                              ? "1px solid #93c5fd"
                              : "1px solid #f0f0f0",
                            boxShadow: item.highlight
                              ? "0 4px 14px rgba(37,99,235,0.18)"
                              : "none",
                            animation: `fadeInUp 0.4s ease ${
                              0.1 * (idx + 1)
                            }s forwards`,
                            opacity: 0,
                          }}
                        >
                          <div
                            style={{
                              width: item.highlight ? 38 : 34,
                              height: item.highlight ? 38 : 34,
                              borderRadius: item.highlight ? "50%" : 8,
                              background: item.highlight
                                ? "linear-gradient(135deg, #3b82f6, #2563eb)"
                                : item.bg,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: item.highlight ? "#fff" : item.color,
                              flexShrink: 0,
                              boxShadow: item.highlight
                                ? "0 3px 10px rgba(37,99,235,0.4)"
                                : "none",
                            }}
                          >
                            {item.icon}
                          </div>
                          <div style={{ minWidth: 0 }}>
                            <div
                              style={{
                                fontSize: 10,
                                color: item.highlight ? "#2563eb" : "#9ca3af",
                                textTransform: "uppercase",
                                letterSpacing: 0.8,
                                fontWeight: 700,
                              }}
                            >
                              {item.label}
                            </div>
                            <div
                              style={{
                                fontSize: item.highlight ? 15 : 13,
                                fontWeight: 700,
                                color: item.highlight ? "#1e40af" : "#1f2937",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {item.value || "-"}
                            </div>
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
                {resultType === "Screening" && resultData.sections && (
                  <div
                    className="mb-4 screening-section"
                    style={{ animationDelay: "0.15s" }}
                  >
                    <h6
                      className="d-flex align-items-center gap-2 mb-3"
                      style={{
                        fontWeight: 700,
                        color: "#374151",
                        fontSize: 14,
                      }}
                    >
                      <div
                        style={{
                          width: 30,
                          height: 30,
                          borderRadius: 8,
                          background:
                            "linear-gradient(135deg, #fef3c7, #fde68a)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Star size={16} style={{ color: "#d97706" }} />
                      </div>
                      Evaluation Sections
                      <Badge
                        pill
                        bg="light"
                        text="dark"
                        style={{ fontSize: 10, fontWeight: 600 }}
                      >
                        {Object.keys(resultData.sections).length}
                      </Badge>
                    </h6>
                    <Row>
                      {Object.entries(resultData.sections).map(
                        ([key, section], idx) => (
                          <Col md={12} key={key}>
                            <div
                              className="screening-question-item"
                              style={{
                                background: "#fff",
                                borderRadius: 12,
                                padding: "16px 18px",
                                border: "1px solid #e5e7eb",
                                animation: `fadeInUp 0.3s ease ${
                                  0.05 * idx
                                }s forwards`,
                                opacity: 0,
                                marginBottom: 10,
                                height: "calc(100% - 10px)",
                              }}
                            >
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <span
                                  style={{
                                    fontSize: 14,
                                    fontWeight: 700,
                                    color: "#1f2937",
                                  }}
                                >
                                  {section.section_name || key}
                                </span>
                                <Badge
                                  pill
                                  style={{
                                    fontSize: 12,
                                    fontWeight: 700,
                                    background:
                                      section.score >= 8
                                        ? "#059669"
                                        : section.score >= 6
                                        ? "#d97706"
                                        : "#dc2626",
                                    border: "none",
                                  }}
                                >
                                  {section.score}/10
                                </Badge>
                              </div>
                              <div
                                style={{
                                  width: "100%",
                                  height: 6,
                                  borderRadius: 3,
                                  background: "#e5e7eb",
                                  marginBottom: 10,
                                }}
                              >
                                <div
                                  style={{
                                    width: `${(section.score / 10) * 100}%`,
                                    height: "100%",
                                    borderRadius: 3,
                                    background:
                                      section.score >= 8
                                        ? "linear-gradient(90deg, #34d399, #059669)"
                                        : section.score >= 6
                                        ? "linear-gradient(90deg, #fbbf24, #d97706)"
                                        : "linear-gradient(90deg, #f87171, #dc2626)",
                                    transition: "width 0.5s ease",
                                  }}
                                />
                              </div>
                              {section.feedback && (
                                <p
                                  className="mb-1"
                                  style={{
                                    fontSize: 12,
                                    color: "#4b5563",
                                    lineHeight: 1.5,
                                  }}
                                >
                                  {section.feedback}
                                </p>
                              )}
                              {section.areas_of_improvement && (
                                <div
                                  className="d-flex align-items-start gap-1 mt-1"
                                  style={{ fontSize: 11, color: "#d97706" }}
                                >
                                  <TrendingUp
                                    size={13}
                                    style={{ flexShrink: 0, marginTop: 2 }}
                                  />
                                  <span>{section.areas_of_improvement}</span>
                                </div>
                              )}
                            </div>
                          </Col>
                        )
                      )}
                    </Row>
                    {(resultData.key_strengths ||
                      resultData.overall_recommendation ||
                      resultData.priority_improvements) && (
                      <Row className="mt-1">
                        {resultData.key_strengths && (
                          <Col md={4}>
                            <div
                              className="d-flex align-items-start gap-2 p-3 mb-2"
                              style={{
                                background: "#ecfdf5",
                                borderRadius: 10,
                                border: "1px solid #a7f3d0",
                                height: "calc(100% - 8px)",
                              }}
                            >
                              <Target
                                size={16}
                                style={{
                                  color: "#059669",
                                  flexShrink: 0,
                                  marginTop: 2,
                                }}
                              />
                              <div>
                                <div
                                  style={{
                                    fontSize: 11,
                                    fontWeight: 700,
                                    color: "#059669",
                                    textTransform: "uppercase",
                                    letterSpacing: 0.5,
                                  }}
                                >
                                  Key Strengths
                                </div>
                                <div style={{ fontSize: 13, color: "#065f46" }}>
                                  {resultData.key_strengths}
                                </div>
                              </div>
                            </div>
                          </Col>
                        )}
                        {resultData.priority_improvements && (
                          <Col md={4}>
                            <div
                              className="d-flex align-items-start gap-2 p-3 mb-2"
                              style={{
                                background: "#fffbeb",
                                borderRadius: 10,
                                border: "1px solid #fde68a",
                                height: "calc(100% - 8px)",
                              }}
                            >
                              <AlertCircle
                                size={16}
                                style={{
                                  color: "#d97706",
                                  flexShrink: 0,
                                  marginTop: 2,
                                }}
                              />
                              <div>
                                <div
                                  style={{
                                    fontSize: 11,
                                    fontWeight: 700,
                                    color: "#d97706",
                                    textTransform: "uppercase",
                                    letterSpacing: 0.5,
                                  }}
                                >
                                  Priority Improvements
                                </div>
                                <div style={{ fontSize: 13, color: "#92400e" }}>
                                  {resultData.priority_improvements}
                                </div>
                              </div>
                            </div>
                          </Col>
                        )}
                        {resultData.overall_recommendation && (
                          <Col md={4}>
                            <div
                              className="d-flex align-items-start gap-2 p-3 mb-2"
                              style={{
                                background: "#eff6ff",
                                borderRadius: 10,
                                border: "1px solid #bfdbfe",
                                height: "calc(100% - 8px)",
                              }}
                            >
                              <Sparkles
                                size={16}
                                style={{
                                  color: "#2563eb",
                                  flexShrink: 0,
                                  marginTop: 2,
                                }}
                              />
                              <div>
                                <div
                                  style={{
                                    fontSize: 11,
                                    fontWeight: 700,
                                    color: "#2563eb",
                                    textTransform: "uppercase",
                                    letterSpacing: 0.5,
                                  }}
                                >
                                  Recommendation
                                </div>
                                <div style={{ fontSize: 13, color: "#1e40af" }}>
                                  {resultData.overall_recommendation}
                                </div>
                              </div>
                            </div>
                          </Col>
                        )}
                      </Row>
                    )}
                  </div>
                )}
                {resultData.questions && resultData.questions.length > 0 && (
                  <div
                    className="mb-4 screening-section"
                    style={{ animationDelay: "0.2s" }}
                  >
                    <h6
                      className="d-flex align-items-center gap-2 mb-3"
                      style={{
                        fontWeight: 700,
                        color: "#374151",
                        fontSize: 14,
                      }}
                    >
                      <div
                        style={{
                          width: 30,
                          height: 30,
                          borderRadius: 8,
                          background:
                            "linear-gradient(135deg, #ede9fe, #ddd6fe)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <ListChecks size={16} style={{ color: "#7c3aed" }} />
                      </div>
                      Screening Questions
                      <Badge
                        pill
                        bg="light"
                        text="dark"
                        style={{ fontSize: 10, fontWeight: 600 }}
                      >
                        {resultData.questions.length}
                      </Badge>
                    </h6>
                    <Row>
                      {resultData.questions.map((q, idx) => (
                        <Col md={6} key={idx}>
                          <div
                            className="d-flex align-items-start gap-3 screening-question-item mb-2"
                            style={{
                              background: "#faf5ff",
                              borderRadius: 10,
                              padding: "12px 16px",
                              borderLeft: "3px solid #7c3aed",
                              animation: `slideInLeft 0.3s ease ${
                                0.05 * idx
                              }s forwards`,
                              opacity: 0,
                              height: "calc(100% - 8px)",
                            }}
                          >
                            <span
                              style={{
                                background:
                                  "linear-gradient(135deg, #7c3aed, #6d28d9)",
                                color: "#fff",
                                borderRadius: "50%",
                                width: 24,
                                height: 24,
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: 11,
                                fontWeight: 700,
                                flexShrink: 0,
                                marginTop: 1,
                                boxShadow: "0 2px 6px rgba(124,58,237,0.3)",
                              }}
                            >
                              {idx + 1}
                            </span>
                            <span
                              style={{
                                fontSize: 13,
                                color: "#374151",
                                lineHeight: 1.5,
                              }}
                            >
                              {q}
                            </span>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                )}
              </div>
              <div className="screening-transcript-pane">
                {resultData.recording && (
                  <div
                    className="mb-3 screening-section"
                    style={{ animationDelay: "0.1s", flexShrink: 0 }}
                  >
                    <h6
                      className="d-flex align-items-center gap-2 mb-2"
                      style={{
                        fontWeight: 700,
                        color: "#374151",
                        fontSize: 13,
                      }}
                    >
                      <div
                        style={{
                          width: 26,
                          height: 26,
                          borderRadius: 7,
                          background:
                            "linear-gradient(135deg, #fef3c7, #fde68a)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Volume2 size={14} style={{ color: "#d97706" }} />
                      </div>
                      Call Recording
                    </h6>
                    <div
                      className="screening-recording-card"
                      style={{
                        background: "linear-gradient(135deg, #fffbeb, #fef3c7)",
                        borderRadius: 12,
                        padding: "12px 14px",
                        border: "1px solid #fde68a",
                      }}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <div
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: "50%",
                            background:
                              "linear-gradient(135deg, #f59e0b, #d97706)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                            boxShadow: "0 4px 12px rgba(245,158,11,0.3)",
                          }}
                        >
                          <Play size={16} style={{ color: "#fff" }} />
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <audio controls style={{ width: "100%", height: 32 }}>
                            <source
                              src={resultData.recording}
                              type="audio/wav"
                            />
                          </audio>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {resultData.transcript && resultData.transcript.length > 0 ? (
                  <div
                    className="screening-section d-flex flex-column"
                    style={{ animationDelay: "0.4s", flex: 1, minHeight: 0 }}
                  >
                    <h6
                      className="d-flex align-items-center gap-2 mb-3"
                      style={{
                        fontWeight: 700,
                        color: "#374151",
                        fontSize: 14,
                        flexShrink: 0,
                      }}
                    >
                      <div
                        style={{
                          width: 30,
                          height: 30,
                          borderRadius: 8,
                          background:
                            "linear-gradient(135deg, #dbeafe, #bfdbfe)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <MessageCircle size={16} style={{ color: "#2563eb" }} />
                      </div>
                      Conversation Transcript
                      <Badge
                        pill
                        style={{
                          fontSize: 10,
                          fontWeight: 600,
                          background:
                            "linear-gradient(135deg, #667eea, #764ba2)",
                          border: "none",
                        }}
                      >
                        {resultData.transcript.length} messages
                      </Badge>
                    </h6>
                    <div
                      className="screening-transcript-container"
                      style={{
                        flex: 1,
                        minHeight: 0,
                        overflowY: "auto",
                        borderRadius: 14,
                        padding: 16,
                        background: "#fff",
                        border: "1px solid #e5e7eb",
                      }}
                    >
                      {resultData.transcript.map((msg, idx) => (
                        <div
                          key={idx}
                          className={`d-flex mb-3 screening-chat-bubble ${
                            msg.role === "ai"
                              ? "justify-content-start"
                              : "justify-content-end"
                          }`}
                          style={{
                            animation: `${
                              msg.role === "ai" ? "slideInLeft" : "slideInRight"
                            } 0.3s ease ${Math.min(idx, 6) * 0.04}s forwards`,
                            opacity: 0,
                          }}
                        >
                          {msg.role === "ai" && (
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip>AI Recruiter</Tooltip>}
                            >
                              <div
                                style={{
                                  width: 34,
                                  height: 34,
                                  borderRadius: "50%",
                                  background:
                                    "linear-gradient(135deg, #667eea, #764ba2)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginRight: 10,
                                  flexShrink: 0,
                                  marginTop: 2,
                                  boxShadow: "0 2px 8px rgba(102,126,234,0.3)",
                                  cursor: "default",
                                }}
                              >
                                <Bot size={17} style={{ color: "#fff" }} />
                              </div>
                            </OverlayTrigger>
                          )}
                          <div
                            style={{
                              maxWidth: "78%",
                              padding: "12px 16px",
                              borderRadius:
                                msg.role === "ai"
                                  ? "4px 18px 18px 18px"
                                  : "18px 4px 18px 18px",
                              background:
                                msg.role === "ai"
                                  ? "#fff"
                                  : "linear-gradient(135deg, #667eea, #764ba2)",
                              color: msg.role === "ai" ? "#1f2937" : "#fff",
                              fontSize: 13,
                              lineHeight: 1.6,
                              boxShadow:
                                msg.role === "ai"
                                  ? "0 2px 8px rgba(0,0,0,0.06)"
                                  : "0 2px 12px rgba(102,126,234,0.3)",
                              border:
                                msg.role === "ai"
                                  ? "1px solid #f0f0f0"
                                  : "none",
                            }}
                          >
                            <div
                              className="d-flex align-items-center gap-1 mb-1"
                              style={{
                                fontSize: 11,
                                fontWeight: 700,
                                opacity: msg.role === "ai" ? 0.5 : 0.8,
                              }}
                            >
                              {msg.role === "ai" ? (
                                <Bot size={11} />
                              ) : (
                                <User size={11} />
                              )}
                              {msg.role === "ai" ? "AI Recruiter" : "Candidate"}
                            </div>
                            <p className="mb-0">{msg.content}</p>
                          </div>
                          {msg.role !== "ai" && (
                            <OverlayTrigger
                              placement="top"
                              overlay={<Tooltip>Candidate</Tooltip>}
                            >
                              <div
                                style={{
                                  width: 34,
                                  height: 34,
                                  borderRadius: "50%",
                                  background:
                                    "linear-gradient(135deg, #34d399, #059669)",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginLeft: 10,
                                  flexShrink: 0,
                                  marginTop: 2,
                                  boxShadow: "0 2px 8px rgba(52,211,153,0.3)",
                                  cursor: "default",
                                }}
                              >
                                <User size={17} style={{ color: "#fff" }} />
                              </div>
                            </OverlayTrigger>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div
                    className="d-flex flex-column align-items-center justify-content-center text-center"
                    style={{ flex: 1, color: "#9ca3af" }}
                  >
                    <MessageCircle
                      size={32}
                      style={{ marginBottom: 10, opacity: 0.5 }}
                    />
                    <small>No transcript available</small>
                  </div>
                )}
              </div>
            </div>
          ) : null}
        </Modal.Body>
        <Modal.Footer
          style={{
            background: "linear-gradient(180deg, #fff, #f9fafb)",
            borderTop: "1px solid #f0f0f0",
            justifyContent: "center",
            padding: "14px 24px",
          }}
        >
          <Button
            variant="secondary"
            className="btn btn-primary blueBtn"
            style={{
              borderRadius: 10,
              padding: "9px 32px",
              fontWeight: 600,
              fontSize: 13,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              transition: "all 0.2s ease",
            }}
            onClick={() => setResultModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
const handleTabChange = tab => {
  if (tab === activeTab) return
  setActiveTab(tab)
  setSearchTerm("")
  setResetPaginationToggle(prev => !prev)
  setPerPage(10)
  setTalentScanPerPage(10)
  if (tab === "telephonic") {
    fetchCallRecords(1, 10, { search: "" })
  } else if (tab === "talentScan") {
    if (!selectedJobId && jobList.length > 0) {
      const firstId = jobList[0].id ?? jobList[0].job_id ?? ""
      if (firstId !== "") setSelectedJobId(String(firstId))
    }
  }
}
  return (
    <div className="page-content allact-tabs">
      <Container fluid>
        <div className="page-title-box mb-0 p-3">
        <div className="telephonic-page-header">
          <h1 className="page-title telephonic-page-title">Telephonic Tests</h1>
        </div>

        <div className="telephonic-filter-panel">
          <div className="telephonic-filter-bar">
            <div className="telephonic-filter-group" style={{ width: 170 }}>
              <label>Select Company</label>
              <CompanySelector onCompanyChange={handleCompanyChange} />
            </div>

            <div className="telephonic-filter-group" style={{ width: 200 }}>
              <label>Job Order</label>
              <Dropdown
                id="jobOrderDropdown"
                value={selectedJobId}
                options={jobList}
                optionLabel="job_title"
                optionValue={j => String(j.id ?? j.job_id ?? "")}
                showClear
                placeholder="All Job Orders"
                style={{ width: "100%", fontSize: 13, }}
                className="job-order-filter-dropdown"
                loading={jobsLoading}
                
                disabled={!companyId}
                emptyMessage={jobsLoading ? "Loading job orders..." : "No jobs found"}
                filter
                filterBy="job_title"
                filterInputAutoFocus={false}
                filterPlaceholder="Search job..."
                onChange={e => setSelectedJobId(e.value || "")}
                filterTemplate={() => (
                  <div
                    className="d-flex align-items-center gap-1 px-2 py-2"
                    style={{ borderBottom: "1px solid #e2e8f0" }}
                    onMouseDown={e => e.stopPropagation()}
                  >
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Search job & press Enter..."
                      value={jobTitleSearch}
                      onChange={e => {
                        const value = e.target.value
                        setJobTitleSearch(value)
                        if (!value.trim()) {
                          fetchJobs(companyId, 1, "")
                        }
                      }}
                      onKeyDown={e => {
                        e.stopPropagation()
                        if (e.key === "Enter") {
                          e.preventDefault()
                          fetchJobs(companyId, 1, jobTitleSearch)
                        }
                      }}
                      style={{ flex: 1 }}
                    />
                    {jobsLoading && (
                      <ProgressSpinner
                        style={{ width: 18, height: 18 }}
                        strokeWidth="6"
                        animationDuration=".8s"
                      />
                    )}
                    {jobTitleSearch && (
                      <button
                        type="button"
                        className="btn btn-sm btn-link p-0 text-secondary"
                        title="Clear search"
                        disabled={jobsLoading}
                        onMouseDown={e => {
                          e.preventDefault()
                          e.stopPropagation()
                        }}
                        onClick={e => {
                          e.preventDefault()
                          e.stopPropagation()
                          setJobTitleSearch("")
                          fetchJobs(companyId, 1, "")
                        }}
                      >
                        <i className="fa fa-times" style={{ fontSize: 12 }} />
                      </button>
                    )}
                  </div>
                )}
                panelFooterTemplate={
                  <div
                    className="d-flex align-items-center justify-content-between px-2 py-2"
                    style={{ borderTop: "1px solid #e2e8f0" }}
                    onMouseDown={e => e.stopPropagation()}
                  >
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      disabled={jobsLoading || jobTitlePage <= 1}
                      onClick={() => fetchJobs(companyId, jobTitlePage - 1, jobTitleSearch)}
                    >
                      ‹ Prev
                    </button>
                    <span style={{ fontSize: 11 }}>
                      {jobsLoading
                        ? "Loading..."
                        : `Page ${jobTitlePage} / ${totalJobTitlePages}`}
                    </span>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      disabled={jobsLoading || jobTitlePage >= totalJobTitlePages}
                      onClick={() => fetchJobs(companyId, jobTitlePage + 1, jobTitleSearch)}
                    >
                      Next ›
                    </button>
                  </div>
                }
              />
            </div>

            {activeTab === "telephonic" && (
              <div className="telephonic-filter-group" style={{ width: 160 }}>
                <label>Screening Status</label>
                <select
                  className="form-select form-select-sm"
                  value={screeningStatus}
                  disabled={!companyId}
                  onChange={e => handleScreeningStatusChange(e.target.value)}
                >
                  <option value="">All</option>
                  {SCREENING_STATUS_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {(activeTab === "telephonic" || activeTab === "talentScan") && (
              <>
                <div className="telephonic-filter-divider" />
                <div className="telephonic-filter-group" style={{ width: 140 }}>
                  <label>From</label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={fromDate}
                    max={toDate || undefined}
                    disabled={!companyId}
                    onChange={e => handleFromDateChange(e.target.value)}
                  />
                </div>
                <div className="telephonic-filter-group" style={{ width: 140 }}>
                  <label>To</label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={toDate}
                    min={fromDate || undefined}
                    disabled={!companyId}
                    onChange={e => handleToDateChange(e.target.value)}
                  />
                </div>
                {activeTab === "talentScan" && (
                  <div className="telephonic-filter-group" style={{ width: 150 }}>
                    <label>Type</label>
                    <select
                      className="form-select form-select-sm"
                      value={talentScanType}
                      disabled={!companyId || !selectedJobId}
                      onChange={e => handleTalentScanTypeChange(e.target.value)}
                    >
                      {TALENT_SCAN_TYPE_OPTIONS.map(opt => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </>
            )}
            <div className="telephonic-filter-divider" />

            <div className="telephonic-filter-group" style={{ width: 200 }}>
              <label>Search</label>
              <div className="telephonic-filter-search-wrap">
                <Search
                  size={14}
                  style={{
                    position: "absolute",
                    left: 10,
                    top: 10,
                    color: "#9ca3af",
                  }}
                />
                <input
                  type="text"
                  className="form-control form-control-sm"
                  style={{
                    paddingLeft: 30,
                    paddingRight: searchTerm ? 28 : 12,
                  }}
                  placeholder="Search candidate…"
                  value={searchTerm}
                  disabled={!companyId}
                  onChange={e => setSearchTerm(e.target.value)}
                />
                {searchTerm && (
                  <button
                    type="button"
                    onClick={() => {
                      setSearchTerm("")
                      if (activeTab === "telephonic") {
                        fetchCallRecords(1, perPage, { search: "" })
                      } else if (activeTab === "talentScan") {
                        fetchTalentScanCandidates(1, talentScanPerPage, {
                          search: "",
                        })
                      }
                    }}
                    style={{
                      position: "absolute",
                      right: 6,
                      top: "50%",
                      transform: "translateY(-50%)",
                      border: "none",
                      background: "none",
                      padding: 2,
                      cursor: "pointer",
                      color: "#9ca3af",
                      lineHeight: 1,
                      display: "flex",
                      alignItems: "center",
                    }}
                    aria-label="Clear search"
                  >
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                    >
                      <path d="M18 6L6 18M6 6l12 12" />
                    </svg>
                  </button>
                )}
              </div>
            </div>
            <Button
              size="sm"
              variant="outline-secondary"
              disabled={!companyId}
              className="telephonic-filter-reset-btn"
              onClick={handleResetFilters}
            >
              Reset
            </Button>
          </div>

          {dateError && <div className="telephonic-date-error">{dateError}</div>}
        </div>
      </div>

        <style>{tableSpacingStyles}</style>
        <div className="telephonic-tab-wrap">
          <div className="telephonic-tab-segment" role="tablist">
            <button
  type="button"
  role="tab"
  aria-selected={activeTab === "telephonic"}
  className={`telephonic-tab-button ${
    activeTab === "telephonic" ? "active" : ""
  }`}
  onClick={() => handleTabChange("telephonic")}
>
  <span>Telephonic Tests</span>
  <span className="telephonic-tab-count">{totalRows || 0}</span>
            </button>
            <button
              type="button"
              role="tab"
              aria-selected={activeTab === "talentScan"}
              className={`telephonic-tab-button ${
                activeTab === "talentScan" ? "active" : ""
              }`}
              onClick={() => handleTabChange("talentScan")}
            >
              <span>Talent Scan Tests</span>
              <span className="telephonic-tab-count">
                {talentScanTotalRows || 0}
              </span>
            </button>
          </div>
         <div className="telephonic-tab-helper d-flex align-items-center" style={{ gap: 10 }}>
          {activeTab === "telephonic" && (
           <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                background: "linear-gradient(135deg, #fef3c7, #fde68a)",
                color: "#92400e",
                fontWeight: 600,
                fontSize: 12,
                padding: "5px 14px",
                borderRadius: 999,
                border: "1px solid #fcd34d",
                boxShadow: "0 2px 6px rgba(217,119,6,0.15)",
                whiteSpace: "nowrap",
              }}
            >
              <span role="img" aria-label="info">⏱️</span>
              <strong>Note :</strong> The score will be updated after 10-15 minutes
            </span>
          )}
          {activeTab === "talentScan" && screeningCutOff !== null && (
             <>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                background: "linear-gradient(135deg, #ede9fe, #ddd6fe)",
                color: "#5b21b6",
                fontWeight: 700,
                fontSize: 12,
                padding: "5px 14px",
                borderRadius: 999,
                border: "1px solid #c4b5fd",
                boxShadow: "0 2px 6px rgba(124,58,237,0.15)",
                whiteSpace: "nowrap",
              }}
            >
              <Target size={13} style={{ color: "#7c3aed" }} />
              Screening Cut Off: {formatPct(screeningCutOff)}
            </span>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                background: "linear-gradient(135deg, #dbeafe, #bfdbfe)",
                color: "#1e40af",
                fontWeight: 600,
                fontSize: 12,
                padding: "5px 14px",
                borderRadius: 999,
                border: "1px solid #93c5fd",
                boxShadow: "0 2px 6px rgba(37,99,235,0.15)",
                whiteSpace: "nowrap",
              }}
            >
              <span role="img" aria-label="info">⏱️</span>
              <strong>Note :</strong> The Test Results will be updated after the evaluation is completed (15-20 minutes)
            </span>
             </>
            
          )}
        </div>
        </div>
        <div className="card p-2 mt-1" id="TelephonicTest_Table">
          <div className="telephonic-table-scroll">
            {activeTab === "telephonic" ? (
              <DataTable
                key={`telephonic-${activeTab}`}
                columns={columns}
                data={records}
                pagination
                paginationServer
                paginationTotalRows={totalRows}
                paginationResetDefaultPage={resetPaginationToggle}
                paginationPerPage={perPage}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
                responsive={false}
                paginationComponentOptions={paginationComponentOptions}
                persistTableHead
                progressPending={loading}
                progressComponent={<CustomLoader />}
              />
            ) : (
              <DataTable
                key={`talentScan-${activeTab}`}
                columns={talentScanColumns}
                data={talentScanRecords}
                pagination
                paginationServer
                paginationTotalRows={talentScanTotalRows}
                paginationResetDefaultPage={resetPaginationToggle}
                paginationPerPage={talentScanPerPage}
                onChangePage={handleTalentScanPageChange}
                onChangeRowsPerPage={handleTalentScanPerRowsChange}
                responsive={false}
                noDataComponent={
                  <div className="telephonic-empty-state">
                    {!companyId
                      ? "Please select a company to view Talent Scan tests."
                      : !selectedJobId
                      ? "Please select a job order to view Talent Scan tests."
                      : "No Talent Scan candidates found."}
                  </div>
                }
                paginationComponentOptions={paginationComponentOptions}
                persistTableHead
                progressPending={talentScanLoading}
                progressComponent={<CustomLoader />}
              />
            )}
          </div>
        </div>
        {renderResultModal()}
        {renderScoreDetailsModal()}
        {renderTalentScanResultModal()}
      </Container>
    </div>
  )
}
export default TelephonicTests
